// import PropTypes from 'prop-types'

import moment from "moment";

const _currencyAbb = `MYR`

export const currencyAbb = _currencyAbb

export const formatDateTimeDisplay = (value) => moment(value).format('YYYY-MM-DD, h:mm:ss a')

export const formatCurrencyDisplay = (val) => {

    // console.log('val', val, Number.isNaN(val))

    if (Number.isNaN(val) || val === "NaN") {
        val = 0
    }

    val = parseFloat(val)
    let number = val; // parseFloat(val.toFixed(2))

    const options = {
        style: 'decimal',  // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    const formattedNumberUS = number.toLocaleString('en-US', options);
    // console.log(formattedNumberUS);

    return `${formattedNumberUS}`;
}

export function useSystemUtils() {

    // promptMessage.propTypes = {
    //     type: PropTypes.bool,
    //     message: PropTypes.string,
    // }

    // const yupValidationHasError = ({ id, errors }) => {

    //     if(!errors?.path) return false;

    //     const { path = '' } = errors;

    //     if(path === id){
    //        return true;
    //     }

    //     return false;
    // }

    // const yupValidationErrorMessage = ({ id, errors: _errors }) => {

    //     if(!_errors?.errors) return <></>

    //     const { errors = [] } = _errors;

    //     if(yupValidationHasError({ id, errors: _errors })){
    //         // return errors.toString();
    //         return errors
    //     }

    //     return "";
    // }

    return {
        currencyAbb,
        formatCurrencyDisplay,
        formatDateTimeDisplay,
        // yupValidationHasError,
        // yupValidationErrorMessage
    }
}